import * as React from 'react';
export const OffersContext = /*#__PURE__*/React.createContext({
  layout: {},
  addOfferToComparison: () => {},
  removeOfferFromComparison: () => {},
  addOfferToFavorites: () => {},
  removeOfferFromFavorites: () => {}
});